import { useData } from 'vike-react/useData';
import type { PageData } from './+data';
import { ChartDisplayPage } from '~/components/ChartDisplayPage';

export default function Page() {
  const { chartInfo, chartData, versions } = useData<PageData>();

  return <ChartDisplayPage chartInfo={chartInfo} chartData={chartData} versions={versions} />;
}
